module.exports = __webpack_public_path__ + "img/d5068e8715a209f9052199a0af6b95a5.png";